// Alternating section backgrounds — spec Section 0.6.5. Even sections white, odd sections
// very light cool gray (#f7f8f7); the first section (Encounter Date, index 0) is white.
export const getRowBackground = (index: number) => (index % 2 === 0 ? 'white' : '#f7f8f7')
export const getRowDarkBackground = (index: number) => (index % 2 === 0 ? 'gray.900' : 'gray.800')

export const formatGa = (totalDays: number) => {
  const weeks = Math.floor(totalDays / 7)
  const days = totalDays % 7
  return `${weeks}w ${days}d`
}

export const formatEncounterDate = (date: string | number) => {
  if (!date) return '—'
  const dateStr = typeof date === 'number' ? new Date(date).toISOString().split('T')[0] : date
  const parts = dateStr.split('-').map(Number)
  if (parts.length === 3 && parts[0] && parts[1] && parts[2]) {
    return new Date(parts[0], parts[1] - 1, parts[2]).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }
  return date
}
